export function createFraudRulesClient(transport) {
    return {
        /**
         * List every tenant's fraud rule-set version headers, without the rules or the digest
         *
         * Requires scope: fraud-rules:platform:read
         */
        listPlatformFraudRuleSets(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/fraud-rule-sets",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/fraud-rule-sets
         *
         * Requires scope: fraud-rules:write
         */
        createFraudRuleSetDraft(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/fraud-rule-sets`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/fraud-rule-sets/{policyKey}/versions/{version}
         *
         * Requires scope: fraud-rules:read
         */
        getFraudRuleSetVersion(tenantId, policyKey, version, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/fraud-rule-sets/${encodeURIComponent(policyKey)}/versions/${encodeURIComponent(version)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/fraud-rule-sets/{policyKey}/versions/{version}/publish
         *
         * Requires scope: fraud-rules:publish
         */
        publishFraudRuleSetVersion(tenantId, policyKey, version, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/fraud-rule-sets/${encodeURIComponent(policyKey)}/versions/${encodeURIComponent(version)}/publish`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/fraud-rule-sets/{policyKey}/versions/{version}/retire
         *
         * Requires scope: fraud-rules:retire
         */
        retireFraudRuleSetVersion(tenantId, policyKey, version, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/fraud-rule-sets/${encodeURIComponent(policyKey)}/versions/${encodeURIComponent(version)}/retire`,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/fraud-rule-sets/{policyKey}/published-artifact
         *
         * Requires scope: fraud-rules:read
         */
        getPublishedFraudRuleArtifact(tenantId, policyKey, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/fraud-rule-sets/${encodeURIComponent(policyKey)}/published-artifact`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=fraud-rules.js.map